import { render, staticRenderFns } from "./widget-table.vue?vue&type=template&id=0282cb28&scoped=true"
import script from "./widget-table.vue?vue&type=script&lang=js"
export * from "./widget-table.vue?vue&type=script&lang=js"
import style0 from "./widget-table.vue?vue&type=style&index=0&id=0282cb28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0282cb28",
  null
  
)

export default component.exports